export default __webpack_public_path__ + "static/media/make-pending.c658ce00.svg";